import React from 'react';
import { useContext } from 'react';
import { ServerContext } from '@goodrx/x-core';
import { SynaptikPromoCode } from './SynaptikPromoCode';
/**
 * Query promo code from synaptik and return appropriate copy
 * @param attrs
 */

export const PromoCodeCopy = () => {
  const {
    synaptik
  } = useContext(ServerContext) || {};
  return synaptik ? /*#__PURE__*/React.createElement(SynaptikPromoCode, {
    synaptik: synaptik
  }) : null;
};